import { UserData } from '@bizzabo/entities';

export const parseUrl = (
    url: string,
    accountId: number,
    eventId: number,
    sessionId: number,
    user: UserData
) => {
    let newUrl = `${url}?accountId=${accountId}&eventId=${eventId}`;

    if (sessionId) {
        newUrl += `&sessionId=${sessionId}`;
    }

    if (user) {
        newUrl += `&userId=${user.id}&userEmail=${user.email}&userFirstName=${user.firstName}&userLastName=${user.lastName}`;
    }

    return newUrl;
};

export const extractOriginFromUrl = (url: string) => new URL(url).origin;
